import Headline from "../../../miscellaneous/Headline";

export default function AboutUs() {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="w-[50%] mb-4 pt-[48px]">
        <Headline value={"ABOUT US"}></Headline>
      </div>
      <div
        data-aos="fade-up"
        className="flex flex-row items-center justify-center"
      >
        <p
          className={`self-center font-poppins text-silver ~text-sm/reg whitespace-normal flex-shrink md:w-1/3 w-[75%] hover:scale-105 duration-250`}
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>BitMillions</b> was
          built by two developers who wanted to create a lottery worth trusting.
          Not because someone promised it was fair — but because the rules are
          written in public code that no one, including us, can change after the
          fact.
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Every draw runs on a
          self-executing smart contract on Base. There is no operator pulling
          numbers, no backend that could fail, and no account to register. You
          connect a wallet, buy a ticket, and if you win, only you can claim
          your prize. Randomness is handled by Chainlink VRF — a cryptographic
          guarantee that winning numbers cannot be known or influenced by anyone
          before they are drawn. Not even us.
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;And every ticket you
          buy contributes to charity — not as a marketing pledge, but as a
          protocol rule. A share of every sale, bounded by hard-coded contract
          rules that the operators can't override, is reserved for a rotating
          set of charitable causes.
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>Play for the prize, stay for the cause.</b>
        </p>
      </div>
    </div>
  );
}
